import React from 'react';
import { TrendingUp, Target, Users, DollarSign, ArrowDown, Share2 } from 'lucide-react';
import { achievements } from '../data/mock';

const iconMap = {
  TrendingUp: TrendingUp,
  Target: Target,
  Users: Users,
  DollarSign: DollarSign,
  ArrowDown: ArrowDown,
  Share2: Share2
};

const Achievements = () => {
  return (
    <section className="py-20 bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4">Results That Matter</h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Proven track record of delivering measurable business impact through data-driven strategies
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {achievements.map((achievement) => {
            const IconComponent = iconMap[achievement.icon];
            return (
              <div
                key={achievement.id}
                className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl p-8 hover:bg-white/10 transition-all duration-300 hover:transform hover:scale-105 hover:shadow-2xl"
              >
                <div className="flex items-start gap-4">
                  <div className="bg-white/10 p-3 rounded-lg">
                    <IconComponent className="w-6 h-6 text-white" />
                  </div>
                  <div>
                    <div className="text-4xl font-bold text-green-400 mb-2">
                      {achievement.metric}
                    </div>
                    <p className="text-gray-300 text-lg">{achievement.description}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Achievements;